import type React from 'react';

/** Violet ink for AI-credit figures, from the design system's AI Credits mark.
 * No palette token corresponds to it. The dark value is not decorative: #3a2597
 * is near-black against the dark dialog surface, so anything painting text with
 * the light ink must pair it with this one. */
export const AI_CREDIT_INK = '#3a2597';
export const AI_CREDIT_INK_DARK = '#c9b8ff';

export const inr = (n: number) => n.toLocaleString('en-IN');

/** Captured from the purchase response rather than read back from the store, so
 * the success screen shows the balances this purchase produced even while a
 * refresh is still in flight. */
export interface PurchaseResult {
  added: number;
  charged: number;
  aiCredits: number;
  credits: number;
}

export interface DialogHeaderProps {
  /** Switches the title once the purchase has gone through. */
  done: boolean;
  onClose: () => void;
}

export interface AmountProps {
  icon: string;
  children: React.ReactNode;
  color?: string;
  /** Required whenever `color` is set: `color` alone is applied in both themes,
   * which is how the AI-credit figures went unreadable in dark mode. */
  colorDark?: string;
  size?: number;
  fontSize?: number;
}

export interface BuyStepProps {
  packSize: number;
  packCost: number;
  maxPacks: number;
  qty: number;
  setQty: (n: number) => void;
  credits: number;
  isLoading: boolean;
  mobile: boolean;
  onBuy: () => void;
  onGetCredits: () => void;
}

export interface SuccessStepProps {
  result: PurchaseResult;
  mobile: boolean;
  onClose: () => void;
}
